import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class Uterus extends mixins(GraphRanges) {
  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  get charts(): MultiChartConfig[] {
    const title = `Cervical Dilation: ${this.cervicalDilation}`;

    return [
      {
        title,
        data: this.graph(["CervicalDilation"]),
        library: this.cervicalDilationConfig,
        suggestedMax: 10
      }
    ];
  }

  get cervicalDilation(): string {
    return (
      _.get(this, "current.body.atoms.cervicalDilation.legend") || "Unknown"
    );
  }
  get cervicalDilationConfig() {
    return {
      scales: {
        yAxes: [
          {
            ticks: {
              min: 0,
              suggestedMax: 10,
              stepSize: 2,
              maxTicksLimit: 11
            }
          }
        ]
      }
    };
  }

  created() {
    this.selectedTime = 0;
  }
}
